export default __webpack_public_path__ + "static/media/portfolio-106.3e16d559.jpg";